module.exports = __webpack_public_path__ + "img/img79.e3c1da3e.png";